import { render } from "./GoogleCallBack.vue?vue&type=template&id=88c574c0&scoped=true"
import script from "@/assets/js/googlecallback.js?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/googlecallback.js?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/googlecallback.css?vue&type=style&index=0&id=88c574c0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c574c0"]])

export default __exports__